import * as wjcGrid from "@grapecity/wijmo.grid"
import { T表紙分割 } from "../../../../components/ComboBox/HyosiBunkatuComboBox"
import { T請求内訳 } from "../../../../components/ComboBox/SeikyuUtiwakeComboBox"
import { T配車入力Grid } from "./haisyaModalConstants"

export const checkId = (
  荷主請求s: T表紙分割[],
  請求内訳s: T請求内訳[],
  flexGrid: wjcGrid.FlexGrid
) => {
  if (flexGrid == null) return
  const sourceCollection: T配車入力Grid[] =
    flexGrid.collectionView.sourceCollection
  sourceCollection.forEach((rowItem) => {
    if (
      !荷主請求s.find(
        (n) =>
          n.荷主ID === rowItem.荷主ID && n.荷主請求ID === rowItem.荷主請求ID
      )
    ) {
      rowItem.荷主請求ID = undefined
      rowItem.荷主請求内訳ID = undefined
    } else if (
      !請求内訳s.find(
        (n) =>
          n.荷主請求ID === rowItem.荷主請求ID &&
          n.荷主請求内訳ID === rowItem.荷主請求内訳ID
      )
    ) {
      rowItem.荷主請求内訳ID = undefined
    }
  })
}
